"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const PortalManager_1 = require("./PortalManager");
function canUseDOM() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function createUniversalPortal(children, selector, portals) {
    if (!canUseDOM()) {
        portals.push([children, selector]); // yes, mutation (҂◡_◡)
        return null; // do not render anything on the server
    }
    // TODO: Do not cast to any when typings are updated for createPortal
    return ReactDOM.createPortal(children, document.querySelector(selector));
}
function prepareClientPortals() {
    if (canUseDOM()) {
        Array.prototype.slice.call(document.querySelectorAll("[data-react-universal-portal]")).forEach(function (node) {
            node.remove();
        });
    }
}
exports.prepareClientPortals = prepareClientPortals;
exports.UniversalPortal = ({ children, selector }) => (React.createElement(PortalManager_1.PortalConsumer, null, (portals) => createUniversalPortal(children, selector, portals)));
